import ACAorange from "../../assets/img/new-home-page/our-partners/ACAorange.jpg";
import D4HI from "../../assets/img/new-home-page/our-partners/D4HI.png";
import NSF from "../../assets/img/new-home-page/our-partners/NSF.png";
import Honorhealthlogo from "../../assets/img/new-home-page/our-partners/honor-health-logo.png";
import Monsoon from "../../assets/img/new-home-page/our-partners/monsoon.png";
import Skydeck from "../../assets/img/new-home-page/our-partners/skydeck.png";
import Weartech from "../../assets/img/new-home-page/our-partners/weartech.png";
import OneFiveOneSeven from "../../assets/img/new-home-page/our-partners/1517.jpeg";

const partnerLogos = [
  ACAorange,
  NSF,
  Honorhealthlogo,
  OneFiveOneSeven,
  Monsoon,
  D4HI,

  Skydeck,
  Weartech,
];

export default function OurPartners() {
  return (
    <section className="tw-relative tw-px-4 sm:tw-px-8 md:tw-px-20 tw-py-10">
      <div className="tw-flex tw-flex-col tw-items-start">
        <h2 className="tw-text-2xl sm:tw-text-3xl md:tw-text-5xl tw-font-extrabold tw-font-sans tw-bg-gradient-to-r tw-from-blue-300 tw-to-green-300 tw-text-transparent tw-bg-clip-text">
          Our Partners
        </h2>

        <div className="tw-grid tw-grid-cols-2 md:tw-grid-cols-4 tw-gap-x-10 tw-gap-y-10 tw-mt-10 tw-w-full">
          {[0, 1, 2, 3].map((colIndex) => (
            <div
              key={colIndex}
              className="tw-flex tw-flex-col tw-items-center tw-gap-y-10"
            >
              <img
                src={partnerLogos[colIndex]}
                alt={`Partner ${colIndex + 1}`}
                className="tw-w-32 tw-h-16 tw-object-contain"
              />
              <img
                src={partnerLogos[colIndex + 4]}
                alt={`Partner ${colIndex + 5}`}
                className="tw-w-32 tw-h-16 tw-object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
